module.exports = __webpack_public_path__ + "images/Thumbs down - line1f3d662f42a59e40157bca0b5218e5e4.svg";